<template>
  <form @submit.prevent="submit()">
    <b-row>
      <b-col sm="8" md="5">
        <b-form-group>
          <label for="item_input">{{ $t('views.exsbwarehouses.show.itemsStatesTable.item') }}</label>
          <model-select required id="item_input" :options="itemOptions" v-model="item.idItem"></model-select>
          <div v-if="isInvalid('idItem')" class="text-danger">
            {{ violations.idItem }}
          </div>
        </b-form-group>
      </b-col>
      <b-col sm="4" md="2" align-self="center" class="mt-2">
        <span>
          <b v-if="basePriceBrutto">
            {{$t('views.exsbpriceuserdata.list.basePriceBrutto')}}:
          </b>
          {{basePriceBrutto}}
        </span>
      </b-col>
      <b-col sm="12" md="5">
        <b-form-group>
          <label for="userdata_input">{{ $t('views.exsbpaymentsmade.list.contractor') }}</label>
          <model-select required id="userdata_input" :options="userDataOptions" v-model="item.idUserData"></model-select>
          <div v-if="isInvalid('idUserData')" class="text-danger">
            {{ violations.idUserData }}
          </div>
        </b-form-group>
      </b-col>
      <b-col sm="12" md="4">
        <b-form-group>
          <label for="vat_rate">{{ $t('views.exsbitems.form.vatRate') }}</label>
          <model-select
            :isDisabled="true"
            id="vat_rate"
            :options="vatRateOptions"
            v-model="item.idVatRate"
            required>
          </model-select>
          <div v-if="isInvalid('idVatRate')" class="text-danger">
            {{ violations.idVatRate }}
          </div>
        </b-form-group>
      </b-col>
      <b-col sm="12" md="4">
        <b-form-group>
          <label for="price_brutto">{{ $t('views.exsbitems.form.priceBrutto') }}:</label>
          <input
            :disabled="!isPriceDisabled"
            :placeholder="$t('views.exsbitems.form.priceBrutto')"
            v-model="item.priceBrutto"
            type="text"
            class="form-control"
            id="price_brutto"
            required
            @input="priceBruttoSelected()">
          <div v-if="isInvalid('priceBrutto')" class="text-danger">
            {{ violations.priceBrutto }}
          </div>
        </b-form-group>
      </b-col>
      <b-col sm="12" md="4">
        <b-form-group>
          <label for="price_brutto">{{ $t('views.exsbitems.form.priceNetto') }}:</label>
          <input
            :disabled="!isPriceDisabled"
            :placeholder="$t('views.exsbitems.form.priceNetto')"
            v-model="item.priceNetto"
            type="text"
            class="form-control"
            id="price_netto"
            required
            @input="priceNettoSelected()">
          <div v-if="isInvalid('priceNetto')" class="text-danger">
            {{ violations.priceNetto }}
          </div>
        </b-form-group>
      </b-col>
    </b-row>
    <button type="button" class="btn btn-success" @click="submit()">{{ $t('buttons.submit') }}</button>
  </form>
</template>

<script>
import { ModelSelect } from 'vue-search-select'
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'Form',
  props: ['values', 'initialValues', 'handleSubmit', 'violations'],

  components: {
    ModelSelect
  },

  data () {
    return {
      vatRateValue: ''
    }
  },

  computed: {
    ...mapGetters({
      itemOptions: 'exsbitem/list/itemOptions',
      items: 'exsbitem/list/items',
      userDataOptions: 'exsbpriceuserdata/list/userDataOptions',
      vatRateOptions: 'exsbvatrate/list/vatRateOptions'
    }),
    item () {
      return this.initialValues || this.values
    },
    isPriceDisabled () {
      return !!this.item.idItem
    },
    basePriceBrutto () {
      if (this.item.idItem) return this.getItemById(this.item.idItem).priceBrutto
      else return null
    }
  },

  watch: {
    'item.idItem': {
      immediate: true,
      handler (val) {
        if (val) {
          this.item.idVatRate = this.getItemById(val).vatRate['@id']
          this.vatRateValue = this.getItemById(val).value
        }
      }
    }
  },

  created () {
    this.fetchItems()
    this.fetchUserDataOptions()
    this.fetchVatRateOptions()
  },

  methods: {
    ...mapActions({
      fetchItems: 'exsbitem/list/getItems',
      fetchUserDataOptions: 'exsbpriceuserdata/list/fetchUserDataOptions',
      fetchVatRateOptions: 'exsbvatrate/list/default'
    }),
    priceBruttoSelected () {
      if (!this.item.priceBrutto) this.item.priceNetto = ''
      else this.setPriceNetto(this.item.priceBrutto)
    },
    priceNettoSelected () {
      if (!this.item.priceNetto) this.item.priceBrutto = ''
      else this.setPriceBrutto(this.item.priceNetto)
    },
    setPriceNetto (priceBrutto) {
      this.item.priceNetto = this.calculatePriceNetto(priceBrutto)
    },
    setPriceBrutto (priceNetto) {
      this.item.priceBrutto = this.calculatePriceBrutto(priceNetto)
    },
    submit () {
      if (typeof this.item.priceBrutto === 'number') this.item.priceBrutto = this.item.priceBrutto.toString()
      if (typeof this.item.priceNetto === 'number') this.item.priceNetto = this.item.priceNetto.toString()
      this.handleSubmit()
    },
    calculatePriceNetto (priceBrutto) {
      let vatRate = (this.getItemById(this.item.idItem).vatRate.value / 100)
      return Math.round((priceBrutto / (1 + vatRate)) * 100) / 100
    },
    calculatePriceBrutto (priceNetto) {
      let vatValue = priceNetto * (this.getItemById(this.item.idItem).vatRate.value / 100)
      return Math.round((parseInt(priceNetto) + vatValue) * 100) / 100
    },
    isInvalid (key) {
      return Object.keys(this.violations).length > 0 && this.violations[key]
    },
    getItemById (id) {
      return this.items.find(entry => {
        return entry['@id'] === id
      })
    }
  }
}
</script>

<style scoped>

</style>
